let _openMenuItem;

const initScrollDirection = () => {
  const pageHeader = document.getElementById('page-header');
  const threshold = 200;
  let lastScrollY = window.scrollY;
  let direction = lastScrollY > threshold ? 'down' : '';
  let timerId;

  if (direction !== '') {
    document.body.classList.add(`navigating-${direction}`);
  }

  window.addEventListener(
    'scroll',
    () => {
      const scrollY = window.scrollY;
      const newDirection
        = scrollY > threshold ? (scrollY >= lastScrollY ? 'down' : 'up') : '';
      lastScrollY = scrollY;

      if (timerId != null) {
        clearTimeout(timerId);
        timerId = undefined;
      }

      if (!newDirection) {
        document.body.classList.remove(`navigating-${direction}`);
        direction = newDirection;
        pageHeader.style.visibility = '';
        return;
      }

      timerId = setTimeout(() => {
        timerId = undefined;
        closeMenuItem();

        if (newDirection === direction) return;

        document.body.classList.remove(`navigating-${direction}`);
        if (newDirection) {
          document.body.classList.add(`navigating-${newDirection}`);
        }

        if (newDirection === 'down' && direction === '') {
          pageHeader.style.visibility = 'hidden';
        } else {
          pageHeader.style.visibility = '';
        }

        direction = newDirection;
      }, 0);
    },
    { passive: true },
  );
};

const showDrawerMenu = (toggleButton, menu) => {
  toggleButton.setAttribute('aria-expanded', 'true');
  menu.setAttribute('aria-modal', 'true');
  menu.setAttribute('role', 'dialog');
  menu.setAttribute('tabindex', '-1');
  document.body.classList.add('drawer-menu');
  menu.addEventListener(
    'transitionend',
    () => {
      menu.focus();
    },
    { once: true },
  );
};

const hideDrawerMenu = (toggleButton, menu) => {
  return new Promise((resolve) => {
    toggleButton.setAttribute('aria-expanded', 'false');
    menu.removeAttribute('aria-modal');
    menu.removeAttribute('role');
    menu.removeAttribute('tabindex');
    menu.addEventListener(
      'transitionend',
      () => {
        document.body.classList.remove('drawer-menu');
        menu.classList.remove('hide');
        resolve();
      },
      { once: true },
    );

    menu.classList.add('hide');
  });
};

const closeMenuItem = () => {
  if (!_openMenuItem) return;

  _openMenuItem.setAttribute('aria-expanded', 'false');
  _openMenuItem.closest('[data-expanded]').setAttribute('data-expanded', 'false');
  _openMenuItem = null;
};

const openMenuItem = (menuItem) => {
  closeMenuItem();

  _openMenuItem = menuItem;
  _openMenuItem.setAttribute('aria-expanded', 'true');
  _openMenuItem.closest('[data-expanded]').setAttribute('data-expanded', 'true');
};

const handleMenuVisibility = () => {
  const menu = document.getElementById('page-menu');
  const toggleButton = document.getElementById('page-menu-toggle');
  const closeButton = menu.querySelector('button');
  const menuLinks = Array.from(menu.querySelectorAll('nav a, nav button'));

  toggleButton.addEventListener('click', (e) => {
    e.stopImmediatePropagation();

    if (toggleButton.ariaExpanded === 'true') {
      hideDrawerMenu(toggleButton, menu);
    } else {
      showDrawerMenu(toggleButton, menu);
    }
  });

  closeButton.addEventListener('click', async (e) => {
    e.stopImmediatePropagation();
    await hideDrawerMenu(toggleButton, menu);
    closeMenuItem();
    setTimeout(() => toggleButton.focus(), 0);
  });

  menuLinks.forEach((menuLink) => {
    const href = menuLink.getAttribute('href') ?? '';
    const landmark
      = href === '#'
        ? document.body.querySelector('a')
        : href.startsWith('/#')
          ? document.getElementById(href.split('#')[1])?.querySelector('h2')
          : null;

    menuLink.addEventListener('click', async (e) => {
      if (menuLink.hasAttribute('aria-expanded')) {
        e.stopImmediatePropagation();
        if (_openMenuItem === menuLink) {
          closeMenuItem();
        } else {
          openMenuItem(menuLink);
          setTimeout(() => menuLink.parentElement.querySelector('ul a').focus(), 0);
        }
      } else if (toggleButton.ariaExpanded === 'true') {
        e.stopImmediatePropagation();
        await hideDrawerMenu(toggleButton, menu);

        if (landmark) {
          setTimeout(() => {
            landmark.setAttribute('tabindex', '-1');
            landmark.focus({ preventScroll: true });
          }, 0);
        }
      }
    });
  });

  menu.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
  });

  document.addEventListener('click', async () => {
    if (toggleButton.ariaExpanded === 'true') {
      await hideDrawerMenu(toggleButton, menu);
      closeMenuItem();
      setTimeout(() => toggleButton.focus(), 0);
    } else {
      closeMenuItem();
    }
  });

  document.addEventListener('keyup', async (e) => {
    if (e.key !== 'Escape') return;

    if (toggleButton.ariaExpanded === 'true') {
      await hideDrawerMenu(toggleButton, menu);
      closeMenuItem();
      setTimeout(() => toggleButton.focus(), 0);
    } else if (_openMenuItem) {
      const parent = _openMenuItem.closest('[data-expanded]').querySelector('[aria-expanded]');
      closeMenuItem();
      setTimeout(() => parent.focus(), 0);
    }
  });

  const selectedMenuLink = menuLinks.find((link) => link.getAttribute('href') === window.location.pathname);
  if (selectedMenuLink) {
    selectedMenuLink.classList.add('selected');
    selectedMenuLink.closest('[data-expanded]')?.querySelector('button').classList.add('selected');
  }
};

const initFixedContactLink = () => {
  const refs = Array.from(document.getElementsByClassName('contact-ref'));
  const observer = new IntersectionObserver((entries) => {
    document.body.classList.toggle(
      'show-fixed-contact-link',
      !entries.some((e) => e.isIntersecting),
    );
  });

  refs.forEach((ref) => observer.observe(ref));
};

export const initNavigation = () => {
  initScrollDirection();
  handleMenuVisibility();
  initFixedContactLink();
};
